module.exports = __webpack_public_path__ + "img/symbol_0.07f9fab6.png";